export const dateTimeFormat = {
    default: "dd/MM/yyyy",
    iso: "yyyy-MM-dd",
    long: "dd MMMM yyyy",
    shortMonth: "dd MMM yyyy",
    shortDate: "dd MMM",
    dayMonthTime: "dd MMM hh:mma",
    time: "h:mm a",
};
